import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TableCell } from '@mui/material';
import * as React from 'react';
import { StrictNumberInput } from 'console/shared/components/fields';
import { ControlWithoutLabel } from 'console/shared/components/fields/control/without-label';
import { minMax, notNullAnd } from 'z3k-parser/validation/basic';
export function PZATableRow(props) {
    const { values, onChangeRow } = props;
    const { temp_out, temp_work } = values;
    function onChangeTempOut(new_value) {
        onChangeRow({ temp_work, temp_out: new_value });
    }
    function onChangeTempWork(new_value) {
        onChangeRow({ temp_work: new_value, temp_out });
    }
    return (_jsxs(_Fragment, { children: [_jsx(TableCell, { children: _jsx(ControlWithoutLabel, { onChange: onChangeTempOut, value: temp_out, field: (input_props) => (_jsx(StrictNumberInput, { ...input_props, min: -40, step: 0.1, max: 20 })), validation_result: notNullAnd(minMax(-40, 20, 'Недопустимое значение'))(temp_out), validation_warnings_result: null }) }), _jsx(TableCell, { children: _jsx(ControlWithoutLabel, { onChange: onChangeTempWork, value: temp_work, field: (input_props) => (_jsx(StrictNumberInput, { ...input_props, min: 20, step: 0.1, max: 100 })), validation_result: notNullAnd(minMax(20, 100, 'Недопустимое значение'))(temp_work), validation_warnings_result: null }) })] }));
}
